module.exports = __webpack_public_path__ + "media/images/icons/icons_large/20_videocamera-f50abde210627a27f9220fea2993d5b2.png";